import ElectricBolt from "@mui/icons-material/ElectricBolt";
import { Stack, Typography } from "@mui/material";

import type { StackProps } from "@mui/material";
import type { FC } from "react";

export const CoPilotHeader: FC<{ beta?: boolean } & StackProps> = (props) => (
  <Stack
    direction="row"
    gap={1}
    sx={{
      position: "relative",
      alignItems: "baseline",
    }}
    {...props}
  >
    <Typography variant="h6">
      <ElectricBolt fontSize="small" sx={{ position: "relative", top: "3px" }} />
      CoPilot
    </Typography>
    <Typography variant="body2" color="info.main">
      beta
    </Typography>
  </Stack>
);
